<template>
<ItpBox
  alignItems="center"
  class="items-spacing w-100"
  v-if="loaded"
>
  <ItpBox
    direction="column"
  >
    <ItpText
      muted
      :text="resourceTitle"
      class="mb-0"
      v-if="resourceTitle"
    >
    </ItpText>
    <ItpText
      tag="h5"
      :text="resourceKey"
      class="mb-0"
    >
    </ItpText>
  </ItpBox>
  <b-button-group
    class="ml-auto"
  >
    <ItpButton
      icon="fa-sync-alt"
      :tooltip="'Reload'|gettext"
      :spinning="actions.reload.isRunning"
      variant="light"
      class="ml-auto"
      v-if="!item.isNew"
      @click.prevent.stop="evh_1040167445267876_clickPreventStop($event, {})"
    >
    </ItpButton>
    <b-dropdown
      right
      variant="light"
      class="border"
      v-if="!item.isNew"
    >
      <ItpIcon
        fa="bars"
        class="mx-1"
        slot="button-content"
      >
      </ItpIcon>
      <ItpButton
        dropdown-item
        :text="'Lock'|pgettext('BtnLockText')"
        :tooltip="'Lock'|pgettext('BtnLockTooltip')"
        variant="default"
        v-if="!item.isNew && item.meta && item.meta.can_lock"
        @click.prevent.stop="evh_3601807637515735_clickPreventStop($event, {})"
      >
      </ItpButton>
      <ItpButton
        dropdown-item
        :text="'Unlock'|pgettext('BtnLockText')"
        :tooltip="'Unlock'|pgettext('BtnLockTooltip')"
        variant="default"
        v-if="!item.isNew && item.meta && item.meta.can_unlock"
        @click.prevent.stop="evh_4139696446929656_clickPreventStop($event, {})"
      >
      </ItpButton>
      <ItpButton
        dropdown-item
        :text="'Invalidate'|pgettext('BtnLockText')"
        :tooltip="'Invalidate'|pgettext('BtnLockTooltip')"
        variant="default"
        v-if="!item.isNew && item.meta && item.meta.can_invalidate"
        @click.prevent.stop="evh_4700643919467772_clickPreventStop($event, {})"
      >
      </ItpButton>
      <ItpButton
        dropdown-item
        :text="'Revoke invalidated'|pgettext('BtnLockText')"
        :tooltip="'Revoke invalidated'|pgettext('BtnLockTooltip')"
        variant="default"
        v-if="!item.isNew && item.meta && item.meta.can_revoke_invalidation"
        @click.prevent.stop="evh_295664594794476_clickPreventStop($event, {})"
      >
      </ItpButton>
      <BtnDeleteResource
        no-icon
        dropdown-item
        :resource="item"
        :tooltip="'Delete'|pgettext('Resource|Command')"
        v-if="!item.isNew && !item.isReadOnly"
        @success="evh_8474446275270171_success($event, {})"
      >
      </BtnDeleteResource>
    </b-dropdown>
  </b-button-group>
</ItpBox>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcBillingListItemHeader extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: Object,
  })
  item!: object;

  @Watch('item')
  onItem(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("item")
  }

  messages!: any;
  ux!: any;
  dataMembers = ['messages', 'ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        messages: {
          newItem: this.$fn.pgettext("BillingListItem", "New item"),
          editItem: this.$fn.pgettext("BillingListItem", "Edit item"),
        }
        ,
        ux: null,
      },
    }
  }

  get resourceTitle() {
    if (this.loaded) {

      return this.$fn.pgettext("BillingListItem", "Billing list item")
    }
    return null;
  }

  get resourceKey() {
    if (this.loaded) {

      return this.item.isNew ? this.messages.newItem : this.messages.editItem
    }
    return null;
  }

  async act_1040167445267876_emit_6844_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_1040167445267876_emit_6844, alias=reload
    return {
      event: "reload",
    }
  }

  async evh_1040167445267876_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1040167445267876_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_3601807637515735_emit_6848_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_3601807637515735_emit_6848, alias=undefined
    return {
      event: "reload",
    }
  }

  async act_3601807637515735_reloadSlickgrid_6850_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_3601807637515735_reloadSlickgrid_6850, alias=undefined
    return {
      grid: "register",
    }
  }

  async act_3601807637515735_request_6846_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_3601807637515735_request_6846, alias=lock
    return {
      operation: "update_register_item",
      data: {
        id: this.item.id,
        etag: this.item.etag,
        locked: true,
      },
    }
  }

  async evh_3601807637515735_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_3601807637515735_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_4139696446929656_emit_6854_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_4139696446929656_emit_6854, alias=undefined
    return {
      event: "reload",
    }
  }

  async act_4139696446929656_reloadSlickgrid_6856_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_4139696446929656_reloadSlickgrid_6856, alias=undefined
    return {
      grid: "register",
    }
  }

  async act_4139696446929656_request_6852_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_4139696446929656_request_6852, alias=lock
    return {
      operation: "update_register_item",
      data: {
        id: this.item.id,
        etag: this.item.etag,
        locked: false,
      },
    }
  }

  async evh_4139696446929656_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_4139696446929656_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_4700643919467772_emit_6860_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_4700643919467772_emit_6860, alias=undefined
    return {
      event: "reload",
    }
  }

  async act_4700643919467772_reloadSlickgrid_6862_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_4700643919467772_reloadSlickgrid_6862, alias=undefined
    return {
      grid: "register",
    }
  }

  async act_4700643919467772_request_6858_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_4700643919467772_request_6858, alias=lock
    return {
      operation: "update_register_item",
      data: {
        id: this.item.id,
        etag: this.item.etag,
        void: true,
      },
    }
  }

  async evh_4700643919467772_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_4700643919467772_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_295664594794476_emit_6866_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_295664594794476_emit_6866, alias=undefined
    return {
      event: "reload",
    }
  }

  async act_295664594794476_reloadSlickgrid_6868_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_295664594794476_reloadSlickgrid_6868, alias=undefined
    return {
      grid: "register",
    }
  }

  async act_295664594794476_request_6864_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_295664594794476_request_6864, alias=lock
    return {
      operation: "update_register_item",
      data: {
        id: this.item.id,
        etag: this.item.etag,
        void: false,
      },
    }
  }

  async evh_295664594794476_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_295664594794476_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_8474446275270171_emit_6870_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_8474446275270171_emit_6870, alias=undefined
    return {
      event: "deleted",
    }
  }

  async evh_8474446275270171_success(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8474446275270171_success.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_1040167445267876_emit_6844: actions.EmitAction;
    evh_1040167445267876_clickPreventStop_6843: actions.EventHandlerImpl;
    evh_1040167445267876_clickPreventStop: actions.EventHandlerGroup;
    act_3601807637515735_emit_6848: actions.EmitAction;
    evh_3601807637515735_success_6847: actions.EventHandlerImpl;
    act_3601807637515735_reloadSlickgrid_6850: actions.ReloadSlickgridAction;
    evh_3601807637515735_success_6849: actions.EventHandlerImpl;
    act_3601807637515735_request_6846: actions.RequestAction;
    evh_3601807637515735_clickPreventStop_6845: actions.EventHandlerImpl;
    evh_3601807637515735_clickPreventStop: actions.EventHandlerGroup;
    act_4139696446929656_emit_6854: actions.EmitAction;
    evh_4139696446929656_success_6853: actions.EventHandlerImpl;
    act_4139696446929656_reloadSlickgrid_6856: actions.ReloadSlickgridAction;
    evh_4139696446929656_success_6855: actions.EventHandlerImpl;
    act_4139696446929656_request_6852: actions.RequestAction;
    evh_4139696446929656_clickPreventStop_6851: actions.EventHandlerImpl;
    evh_4139696446929656_clickPreventStop: actions.EventHandlerGroup;
    act_4700643919467772_emit_6860: actions.EmitAction;
    evh_4700643919467772_success_6859: actions.EventHandlerImpl;
    act_4700643919467772_reloadSlickgrid_6862: actions.ReloadSlickgridAction;
    evh_4700643919467772_success_6861: actions.EventHandlerImpl;
    act_4700643919467772_request_6858: actions.RequestAction;
    evh_4700643919467772_clickPreventStop_6857: actions.EventHandlerImpl;
    evh_4700643919467772_clickPreventStop: actions.EventHandlerGroup;
    act_295664594794476_emit_6866: actions.EmitAction;
    evh_295664594794476_success_6865: actions.EventHandlerImpl;
    act_295664594794476_reloadSlickgrid_6868: actions.ReloadSlickgridAction;
    evh_295664594794476_success_6867: actions.EventHandlerImpl;
    act_295664594794476_request_6864: actions.RequestAction;
    evh_295664594794476_clickPreventStop_6863: actions.EventHandlerImpl;
    evh_295664594794476_clickPreventStop: actions.EventHandlerGroup;
    act_8474446275270171_emit_6870: actions.EmitAction;
    evh_8474446275270171_success_6869: actions.EventHandlerImpl;
    evh_8474446275270171_success: actions.EventHandlerGroup;
  }

  getActions() {
    const act_1040167445267876_emit_6844 = new actions.EmitAction(
      {
        actionArgs: this.act_1040167445267876_emit_6844_getActionArgs,
        displayName: "reload",
        events: [],
      }
    );
    const evh_1040167445267876_clickPreventStop_6843 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_emit_6844,
        event: "click.prevent.stop",
        displayName: "reload",
      }
    );
    const evh_1040167445267876_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1040167445267876_clickPreventStop_6843],
      }
    );
    const act_3601807637515735_emit_6848 = new actions.EmitAction(
      {
        actionArgs: this.act_3601807637515735_emit_6848_getActionArgs,
        events: [],
      }
    );
    const evh_3601807637515735_success_6847 = new actions.EventHandlerImpl(
      {
        action: act_3601807637515735_emit_6848,
        event: "success",
        displayName: "emit",
      }
    );
    const act_3601807637515735_reloadSlickgrid_6850 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_3601807637515735_reloadSlickgrid_6850_getActionArgs,
        events: [],
      }
    );
    const evh_3601807637515735_success_6849 = new actions.EventHandlerImpl(
      {
        action: act_3601807637515735_reloadSlickgrid_6850,
        event: "success",
        displayName: "reloadSlickgrid",
      }
    );
    const act_3601807637515735_request_6846 = new actions.RequestAction(
      {
        actionArgs: this.act_3601807637515735_request_6846_getActionArgs,
        displayName: "lock",
        events: [evh_3601807637515735_success_6847, evh_3601807637515735_success_6849],
      }
    );
    const evh_3601807637515735_clickPreventStop_6845 = new actions.EventHandlerImpl(
      {
        action: act_3601807637515735_request_6846,
        event: "click.prevent.stop",
        displayName: "lock",
      }
    );
    const evh_3601807637515735_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_3601807637515735_clickPreventStop_6845],
      }
    );
    const act_4139696446929656_emit_6854 = new actions.EmitAction(
      {
        actionArgs: this.act_4139696446929656_emit_6854_getActionArgs,
        events: [],
      }
    );
    const evh_4139696446929656_success_6853 = new actions.EventHandlerImpl(
      {
        action: act_4139696446929656_emit_6854,
        event: "success",
        displayName: "emit",
      }
    );
    const act_4139696446929656_reloadSlickgrid_6856 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_4139696446929656_reloadSlickgrid_6856_getActionArgs,
        events: [],
      }
    );
    const evh_4139696446929656_success_6855 = new actions.EventHandlerImpl(
      {
        action: act_4139696446929656_reloadSlickgrid_6856,
        event: "success",
        displayName: "reloadSlickgrid",
      }
    );
    const act_4139696446929656_request_6852 = new actions.RequestAction(
      {
        actionArgs: this.act_4139696446929656_request_6852_getActionArgs,
        displayName: "lock",
        events: [evh_4139696446929656_success_6853, evh_4139696446929656_success_6855],
      }
    );
    const evh_4139696446929656_clickPreventStop_6851 = new actions.EventHandlerImpl(
      {
        action: act_4139696446929656_request_6852,
        event: "click.prevent.stop",
        displayName: "lock",
      }
    );
    const evh_4139696446929656_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_4139696446929656_clickPreventStop_6851],
      }
    );
    const act_4700643919467772_emit_6860 = new actions.EmitAction(
      {
        actionArgs: this.act_4700643919467772_emit_6860_getActionArgs,
        events: [],
      }
    );
    const evh_4700643919467772_success_6859 = new actions.EventHandlerImpl(
      {
        action: act_4700643919467772_emit_6860,
        event: "success",
        displayName: "emit",
      }
    );
    const act_4700643919467772_reloadSlickgrid_6862 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_4700643919467772_reloadSlickgrid_6862_getActionArgs,
        events: [],
      }
    );
    const evh_4700643919467772_success_6861 = new actions.EventHandlerImpl(
      {
        action: act_4700643919467772_reloadSlickgrid_6862,
        event: "success",
        displayName: "reloadSlickgrid",
      }
    );
    const act_4700643919467772_request_6858 = new actions.RequestAction(
      {
        actionArgs: this.act_4700643919467772_request_6858_getActionArgs,
        displayName: "lock",
        events: [evh_4700643919467772_success_6859, evh_4700643919467772_success_6861],
      }
    );
    const evh_4700643919467772_clickPreventStop_6857 = new actions.EventHandlerImpl(
      {
        action: act_4700643919467772_request_6858,
        event: "click.prevent.stop",
        displayName: "lock",
      }
    );
    const evh_4700643919467772_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_4700643919467772_clickPreventStop_6857],
      }
    );
    const act_295664594794476_emit_6866 = new actions.EmitAction(
      {
        actionArgs: this.act_295664594794476_emit_6866_getActionArgs,
        events: [],
      }
    );
    const evh_295664594794476_success_6865 = new actions.EventHandlerImpl(
      {
        action: act_295664594794476_emit_6866,
        event: "success",
        displayName: "emit",
      }
    );
    const act_295664594794476_reloadSlickgrid_6868 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_295664594794476_reloadSlickgrid_6868_getActionArgs,
        events: [],
      }
    );
    const evh_295664594794476_success_6867 = new actions.EventHandlerImpl(
      {
        action: act_295664594794476_reloadSlickgrid_6868,
        event: "success",
        displayName: "reloadSlickgrid",
      }
    );
    const act_295664594794476_request_6864 = new actions.RequestAction(
      {
        actionArgs: this.act_295664594794476_request_6864_getActionArgs,
        displayName: "lock",
        events: [evh_295664594794476_success_6865, evh_295664594794476_success_6867],
      }
    );
    const evh_295664594794476_clickPreventStop_6863 = new actions.EventHandlerImpl(
      {
        action: act_295664594794476_request_6864,
        event: "click.prevent.stop",
        displayName: "lock",
      }
    );
    const evh_295664594794476_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_295664594794476_clickPreventStop_6863],
      }
    );
    const act_8474446275270171_emit_6870 = new actions.EmitAction(
      {
        actionArgs: this.act_8474446275270171_emit_6870_getActionArgs,
        events: [],
      }
    );
    const evh_8474446275270171_success_6869 = new actions.EventHandlerImpl(
      {
        action: act_8474446275270171_emit_6870,
        event: "success",
        displayName: "emit",
      }
    );
    const evh_8474446275270171_success = new actions.EventHandlerGroup(
      {
        handlers: [evh_8474446275270171_success_6869],
      }
    );
    return {
      act_1040167445267876_emit_6844,
      evh_1040167445267876_clickPreventStop_6843,
      evh_1040167445267876_clickPreventStop,
      act_3601807637515735_emit_6848,
      evh_3601807637515735_success_6847,
      act_3601807637515735_reloadSlickgrid_6850,
      evh_3601807637515735_success_6849,
      act_3601807637515735_request_6846,
      evh_3601807637515735_clickPreventStop_6845,
      evh_3601807637515735_clickPreventStop,
      act_4139696446929656_emit_6854,
      evh_4139696446929656_success_6853,
      act_4139696446929656_reloadSlickgrid_6856,
      evh_4139696446929656_success_6855,
      act_4139696446929656_request_6852,
      evh_4139696446929656_clickPreventStop_6851,
      evh_4139696446929656_clickPreventStop,
      act_4700643919467772_emit_6860,
      evh_4700643919467772_success_6859,
      act_4700643919467772_reloadSlickgrid_6862,
      evh_4700643919467772_success_6861,
      act_4700643919467772_request_6858,
      evh_4700643919467772_clickPreventStop_6857,
      evh_4700643919467772_clickPreventStop,
      act_295664594794476_emit_6866,
      evh_295664594794476_success_6865,
      act_295664594794476_reloadSlickgrid_6868,
      evh_295664594794476_success_6867,
      act_295664594794476_request_6864,
      evh_295664594794476_clickPreventStop_6863,
      evh_295664594794476_clickPreventStop,
      act_8474446275270171_emit_6870,
      evh_8474446275270171_success_6869,
      evh_8474446275270171_success,
      reload: act_1040167445267876_emit_6844,
      lock: act_295664594794476_request_6864,
    }
  }
}

Vue.component("UcBillingListItemHeader", UcBillingListItemHeader);

</script>